import { apiDelete, apiGet, apiPost, apiPut } from '../_common';

export default {
  // month as YYYY-MM
  reconcile(month) {
    return apiGet('/magenta/fiscal/purchase-reconciliation', { month }).then(result => result.response);
  },
  link(blingId, purchaseInvoiceId) {
    return apiPost(`/magenta/fiscal/purchase-order/${blingId}/invoice/${purchaseInvoiceId}`, {})
      .then(result => result.response);
  },
  unlink(blingId, purchaseInvoiceId) {
    return apiDelete(`/magenta/fiscal/purchase-order/${blingId}/invoice/${purchaseInvoiceId}`);
  },
  updateFulfilledAt(blingId, fulfilledAt) {
    return apiPut(`/magenta/fiscal/purchase-order/${blingId}/fulfilled-at`, { fulfilledAt })
      .then(result => result.response);
  },
  resync(blingId) {
    return apiPost(`/magenta/fiscal/purchase-order/${blingId}/resync`, {}).then(result => result.response);
  },
};
